import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router'
import ProjectThumbnail from './ProjectThumbnail'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Project } from '../../schema/types.d'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { navPage } from './ProjectPage'

interface TitleProps {
  name: string
  onClick: () => void
  icon: IconProp
}

class NavigationTitle extends Component<TitleProps> {
  render() {
    return (
      <div className="menu-item dim pointer">
        <FontAwesomeIcon icon={this.props.icon} color="#bdd1e4" />
        <a
          href="#"
          onClick={this.props.onClick.bind(this)}
          className="f6 no-underline black-50 pl3"
        >
          {this.props.name}
        </a>
      </div>
    )
  }
}
interface ProjectMenuBarProps {
  project: Project.Project
  changePage: (newPage: navPage) => void
}

class ProjectMenuBar extends Component<ProjectMenuBarProps> {
  constructor(props) {
    super(props)
    this.changePageHandler.bind(this)
  }

  changePageHandler(page: navPage) {
    this.props.changePage(page)
  }
  render() {
    return (
      <div className="rectangle-copy-4">
        <ProjectThumbnail project={this.props.project} />
        <div className="pa2">
          <NavigationTitle
            name="Project Details"
            icon="bars"
            onClick={() => this.changePageHandler(navPage.projectDetail)}
          />
          <NavigationTitle
            name="Work Planner - Gantt"
            icon="chart-line"
            onClick={() => this.changePageHandler(navPage.workPlanner)}
          />
          <NavigationTitle
            name="Work Planner - Table"
            icon="table"
            onClick={() => this.changePageHandler(navPage.workPlannerTable)}
          />
        </div>
      </div>
    )
  }
}

export default ProjectMenuBar
